import { Exception } from '../Exception';
export class ConnectionException extends Exception {
  constructor(message: string) {
    super(message);
  }
}
